import React from 'react'
import { createRoot } from 'react-dom/client'
import { HelmetProvider } from 'react-helmet-async'
import { ConfigProvider } from 'antd';
import enUS from 'antd/locale/en_US';
import 'dayjs/locale/en';
import App from './App'
import '@app/styles/main.scss'

const container = document.getElementById('root')
const root = createRoot(container)
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <ConfigProvider locale={enUS}>
        <App />
      </ConfigProvider>
    </HelmetProvider>
  </React.StrictMode>
)